module.exports = __webpack_public_path__ + "i18n/pt-BR.96af46f6f6ea0a061f9fb881f8f302e3.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=i18n/[name].[hash].[ext]!./i18n/pt-BR.json
// module id = 1003
// module chunks = 60